<template>
  <img
    class="h-7 w-auto"
    src="/webflow-assets/images/360ai-logo.svg"
    alt="360AI Logo"
  />
</template>
